module.exports = __webpack_public_path__ + "static/media/Bambu-Lomas-Logo.d2aeefb3.png";